// Mock AWS X-Ray SDK for browser environment
// This prevents the async_hooks error by providing a no-op implementation

const mockXRay = {
  captureAWS: function(aws) {
    return aws;
  },
  captureAWSClient: function(client) {
    return client;
  },
  captureHTTPsGlobal: function() {
    // No-op in browser
  },
  capturePromise: function() {
    // No-op in browser
  },
  captureAsyncFunc: function() {
    // No-op in browser
  },
  captureFunc: function() {
    // No-op in browser
  },
  captureCallback: function() {
    // No-op in browser
  },
  getSegment: function() {
    return null;
  },
  setSegment: function() {
    // No-op in browser
  },
  getNamespace: function() {
    return {
      run: function(fn) {
        return fn();
      },
      bind: function(fn) {
        return fn;
      }
    };
  },
  createNamespace: function() {
    return {
      run: function(fn) {
        return fn();
      },
      bind: function(fn) {
        return fn;
      }
    };
  }
};

module.exports = mockXRay;
module.exports.default = mockXRay;
